import React from 'react';
import './App.css';
// import logo from './imagenes/logo.png';
import ListaDeTareas from './componentes/ListaDeTareas';
import { AiOutlineCheckCircle } from "react-icons/ai";

function App() {
  return (
    <div className="aplicacion-tareas">
      <div className="logo-contenedor">
        <h1 className="tareas-encabezado">
          <AiOutlineCheckCircle style={{ marginRight: '10px' }} />
          To-Do List
        </h1>
        {/* <img 
          src={logo} 
          className="logo" alt="Logo de la aplicación To-Do List"/> */}
      </div>
      <div className='tareas-lista-principal'>


        <h1>Tareas</h1>
        <ListaDeTareas />
      </div>
    </div>
  );
}

export default App;
